import { AppEnvironment, EnvironmentConfig } from '@core/api';
import { AppLicense } from '@core/licenses';

export const API_URL_CONFIG: Record<AppEnvironment, EnvironmentConfig> = {
  [AppEnvironment.Dev]: {
    [AppLicense.KZ]: {
      apiHost: 'https://gw-bo.kz.dev.product.pin-up.dev/api/v1',
      grpcHost: 'https://gw-bo.kz.dev.product.pin-up.dev',
    },
    [AppLicense.COM]: {
      apiHost: 'https://com-gw-bo-base.pin-up.dev/cas/api/v1',
      grpcHost: 'https://gw-bo.kz.dev.product.pin-up.dev',
    },
    [AppLicense.WL]: {
      apiHost: 'https://gw-bo.devpincowin.tech/cas/api/v1',
      grpcHost: 'https://gw-bo.devpincowin.tech'
    }
  },
  [AppEnvironment.Stage]: {
    [AppLicense.KZ]: {
      apiHost: 'https://gw-bo.kz.dev.product.pin-up.dev/api/v1',
      grpcHost: 'https://gw-bo.kz.dev.product.pin-up.dev',
    },
    [AppLicense.COM]: {
      apiHost: 'https://com-gw-bo-base.pin-up.dev/cas/api/v1',
      grpcHost: 'https://com-gw-bo-base.pin-up.dev',
    },
    [AppLicense.WL]: {
      apiHost: ' '
    }
  },
  [AppEnvironment.Prod]: {
    [AppLicense.KZ]: {
      apiHost: 'https://gw-bo.pin-up.kz/api/v1',
      grpcHost: 'https://gw-bo.pin-up.kz',
    },
    [AppLicense.COM]: {
      apiHost: '',
    },
    [AppLicense.WL]: {
      apiHost: ' '
    }
  },
};
